import styled from "styled-components";
import PanelAreaField from "./PanelAreaField";
import {
  areaFieldColors,
  areaPositionNavPointUpdate,
  areaPositionNavSelectionGet,
  findAreaFieldIndex,
  initialAreaPositionNavGet,
  structureAreasUpdateGet,
} from "./PanelAreaFieldList.logic";
import { PANEL_AREA_DEFAULT_DIMENSION } from "./PanelAreaFieldList.constant";
import { AreaPosition, AreaSource } from "type/panel/Panel.type";
import { useEffect, useState } from "react";
import { AreaPositionNav } from "./PanelAreaFieldList.type";

type Props = {
  areas: AreaSource[];
  selectedAreaInd: number | null;
  onAreasUpdate: Function;
};

const PanelAreaFieldList = ({
  areas,
  selectedAreaInd,
  onAreasUpdate,
}: Props) => {
  const [areaPositionNav, setAreaPositionNav] = useState<AreaPositionNav>(
    initialAreaPositionNavGet()
  );
  useEffect(() => {
    const areaPosition: AreaPosition | null =
      areaPositionNavSelectionGet(areaPositionNav);
    if (areaPosition !== null) {
      console.log("area position selected", areaPosition);
      const areasNext: AreaSource[] = structureAreasUpdateGet(
        areas,
        selectedAreaInd,
        areaPosition
      );
      console.log("areasNext", areasNext);
      onAreasUpdate(areasNext);
    }
  }, [areaPositionNav]);
  useEffect(() => {
    console.log("useEffect - areas", areas);
  }, [areas]);

  const fieldClickHandle = (rowStart: number, columnStart: number) => {
    console.log("click", rowStart, columnStart);
    if (selectedAreaInd !== null) {
      const areasUpdated = [...areas];
      console.log("fieldClickHandle", rowStart, columnStart);
      const areaPositionNavNext: AreaPositionNav = areaPositionNavPointUpdate(
        columnStart,
        rowStart,
        areaPositionNav
      );
      setAreaPositionNav(areaPositionNavNext);
    }
  };

  const areaFields: React.ReactElement[] = [];
  for (let j = 0; j < PANEL_AREA_DEFAULT_DIMENSION.HEIGHT; j++) {
    for (let i = 0; i < PANEL_AREA_DEFAULT_DIMENSION.WIDTH; i++) {
      const indN: number[] = findAreaFieldIndex(i, j, areas);
      const colors: string[] = areaFieldColors(indN);
      areaFields.push(
        <PanelAreaField
          colors={colors}
          key={`area_field_${i}_${j}`}
          columnStart={i}
          rowStart={j}
          clickHandle={() => fieldClickHandle(j, i)}
          areaFieldSelected={
            selectedAreaInd !== null ? indN.includes(selectedAreaInd) : false
          }
        />
      );
    }
  }
  return <>{areaFields}</>;
};

// const DivAreasNav = styled.div`
//   display: flex;
//   width: 100%;
// `;

export default PanelAreaFieldList;
